import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Group from 'flarum/common/models/Group';
import Select from 'flarum/common/components/Select';
import RecipientPicker from '../../common/components/RecipientPicker';
import { parseRecipients, resolveRecipients } from '../../common/utils/recipients';
import { getContrastTextColor } from '../../common/utils/color';
export default class NotificationUserModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "sending", false);
    _defineProperty(this, "recipients", []);
    _defineProperty(this, "messageText", '');
    _defineProperty(this, "notificationUrl", '');
    _defineProperty(this, "notificationIcon", '');
    _defineProperty(this, "allUsersText", null);
    _defineProperty(this, "notificationTypes", null);
    _defineProperty(this, "selectedNotificationType", '');
    _defineProperty(this, "loadingTypes", false);
    _defineProperty(this, "loadingRecipients", false);
    /** Incremented every time updateFields() runs; used to discard stale async recipient lookups. */
    _defineProperty(this, "recipientsLoadToken", 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.recipients = [];
    if (this.attrs.user) {
      this.recipients.push(this.attrs.user);
    }
    if (this.attrs.forAll) {
      const membersGroup = app.store.getById('groups', Group.MEMBER_ID);
      this.recipients.push(membersGroup);
      this.allUsersText = app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.preview_all_members');
    } else {
      this.allUsersText = null;
    }
    this.loadNotificationTypes();
  }
  async loadNotificationTypes() {
    this.loadingTypes = true;
    m.redraw();
    try {
      await app.store.find('notification-types');
      const allTypes = app.store.all('notification-types');
      const activeTypes = allTypes.filter(item => item.attribute('is_active'));
      const userGroups = app.session.user ? (app.session.user.groups() || []).map(g => g.id()) : [];
      const isAdmin = app.session.user && app.session.user.isAdmin();
      const allowedTypes = activeTypes.filter(item => {
        if (isAdmin) return true;
        const perm = item.attribute('permission');
        if (!perm) return true;
        const allowedGroupIds = perm.split(',');
        return allowedGroupIds.some(id => userGroups.includes(id));
      });
      this.notificationTypes = allowedTypes.sort((a, b) => {
        var _a$attribute, _b$attribute;
        return ((_a$attribute = a.attribute('sort_order')) != null ? _a$attribute : 0) - ((_b$attribute = b.attribute('sort_order')) != null ? _b$attribute : 0);
      });
      if (this.notificationTypes.length > 0) {
        this.selectedNotificationType = this.notificationTypes[0].id();
        this.updateFields(this.notificationTypes[0]);
      }
    } catch (error) {
      console.error('Failed to load notification types:', error);
    } finally {
      this.loadingTypes = false;
      m.redraw();
    }
  }
  updateFields(type) {
    this.notificationUrl = type.attribute('default_url') || '';
    this.notificationIcon = type.attribute('default_icon') || '';
    this.messageText = type.attribute('default_message_key') || '';

    // Bump the token so any in-flight lookups from a previous type selection
    // discard their results instead of mutating the (now stale) recipients list.
    this.recipientsLoadToken += 1;
    const token = this.recipientsLoadToken;
    const isStale = () => token !== this.recipientsLoadToken;
    const defaultRecipients = type.attribute('default_recipients');
    const refs = parseRecipients(defaultRecipients);
    if (refs.length === 0) {
      this.recipients = [];
      if (this.attrs.user) {
        this.recipients.push(this.attrs.user);
      }
      if (this.attrs.forAll) {
        const membersGroup = app.store.getById('groups', Group.MEMBER_ID);
        this.recipients.push(membersGroup);
      }
      this.loadingRecipients = false;
      m.redraw();
      return;
    }
    this.recipients = [];
    this.loadingRecipients = true;
    m.redraw();
    resolveRecipients(refs, recipient => {
      this.recipients.push(recipient);
    }, () => {
      this.loadingRecipients = false;
      m.redraw();
    }, isStale);
  }
  className() {
    return 'huseyinfilizNotificationModal Modal--large';
  }
  title() {
    return app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.title_text');
  }
  onready() {
    this.$('form').find('.js-focus-on-load').first().focus().select();
  }
  content() {
    return m('.Modal-body', m('form.Form', {
      onsubmit: this.onsubmit.bind(this)
    }, [this.recipientsField(), this.typeSelectorField(), this.messageField(), this.urlField(), this.previewField(), this.submitButtonField()]));
  }
  recipientsField() {
    return m('.Form-group', [m('label', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.recipients_label')), this.loadingRecipients ? LoadingIndicator.component({
      size: 'small'
    }) : m(RecipientPicker, {
      recipients: this.recipients,
      onChange: recipients => {
        this.recipients = recipients;
      },
      searchGroups: app.forum.huseyinfilizNotificationAll(),
      searchUsers: true,
      disabled: this.sending,
      translationPrefix: 'huseyinfiliz-notificationhub.forum'
    })]);
  }
  typeSelectorField() {
    const notificationTypeOptions = {};
    let selectBody = 'Custom';
    if (this.notificationTypes && this.notificationTypes.length > 0) {
      this.notificationTypes.forEach(type => {
        notificationTypeOptions[type.id()] = type.attribute('name');
      });
      selectBody = m(Select, {
        options: notificationTypeOptions,
        value: this.selectedNotificationType,
        onchange: value => {
          this.selectedNotificationType = value;
          const selectedType = this.notificationTypes.find(type => type.id() === value);
          if (selectedType) {
            this.updateFields(selectedType);
          }
        },
        disabled: this.sending
      });
    } else {
      selectBody = m('p', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.no_notification_types'));
    }
    return m('.Form-group', [m('label', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.notification_type_label')), this.loadingTypes ? m(LoadingIndicator, {
      size: 'small'
    }) : selectBody]);
  }
  messageField() {
    return m('.Form-group', [m('label', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.message_label')), m('textarea.FormControl', {
      rows: 5,
      value: this.messageText,
      oninput: event => {
        this.messageText = event.target.value;
      },
      placeholder: app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.preview_message_placeholder'),
      disabled: this.sending
    })]);
  }
  urlField() {
    return m('.Form-group', [m('label', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.url_label')), m('input[type=text].FormControl', {
      value: this.notificationUrl,
      oninput: event => {
        this.notificationUrl = event.target.value;
      },
      placeholder: app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.url_placeholder'),
      disabled: this.sending
    })]);
  }
  previewField() {
    var _this$notificationTyp, _app$session$user$use;
    const selectedType = (_this$notificationTyp = this.notificationTypes) == null ? void 0 : _this$notificationTyp.find(type => type.id() === this.selectedNotificationType);
    const previewColor = (selectedType == null ? void 0 : selectedType.attribute('color')) || null;
    const textColor = getContrastTextColor(previewColor);
    return m('.Form-group', [m('label', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.preview_title')), m('.HeaderList.NotificationList.NotificationPreview-content', m('.HeaderList-content', m('.HeaderListGroup', m('ul.HeaderListGroup-content', m('li', m("a.HeaderListItem.Notification.Notification--customNotification", {
      style: previewColor ? _objectSpread({
        backgroundColor: previewColor
      }, textColor ? {
        '--notificationhub-text-color': textColor
      } : {}) : {}
    }, [m('span.Avatar', {
      style: app.session.user ? {
        'background-image': app.session.user.avatarUrl() ? "url(".concat(app.session.user.avatarUrl(), ")") : null,
        'background-color': !app.session.user.avatarUrl() ? '#e5a2a0' : null
      } : {}
    }, app.session.user && !app.session.user.avatarUrl() ? (_app$session$user$use = app.session.user.username()) == null ? void 0 : _app$session$user$use.charAt(0).toUpperCase() : null), m('i.icon.HeaderListItem-icon', {
      className: this.notificationIcon ? "icon ".concat(this.notificationIcon, " HeaderListItem-icon") : 'icon fas fa-bell HeaderListItem-icon'
    }), m('span.HeaderListItem-title', m('span.HeaderListItem-content', m('div.NotificationPreview-messageText', this.messageText || m('em', app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.preview_message_placeholder')))), m('span.HeaderListItem-title-spring')), m('div.HeaderListItem-actions'), m('div.HeaderListItem-excerpt', this.selectedNotificationType ? String((selectedType == null ? void 0 : selectedType.attribute('excerpt_key')) || '') : '')]))))))]);
  }
  submitButtonField() {
    return m('.Form-group', [Button.component({
      type: 'submit',
      className: 'Button Button--primary SendNotificationModal-send',
      loading: this.sending,
      disabled: this.recipients.length === 0 || this.messageText === '' || !this.selectedNotificationType || this.loadingRecipients
    }, app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.submit_button'))]);
  }
  onsubmit(event) {
    event.preventDefault();
    this.sending = true;
    m.redraw();
    const selectedUsers = this.recipients.filter(r => r.data.type === 'users').map(r => r.id());
    const selectedGroups = this.recipients.filter(r => r.data.type === 'groups').map(r => r.id());
    this.sendNotification(selectedUsers, selectedGroups);
  }
  sendNotification(selectedUsers, selectedGroups) {
    this.sending = true;
    m.redraw();
    const requestBody = {
      message: this.messageText,
      fromUserId: app.session.user.id(),
      userIds: selectedUsers,
      groupIds: selectedGroups,
      url: this.notificationUrl,
      icon: this.notificationIcon,
      subjectId: this.selectedNotificationType
    };
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/notifications/send',
      body: requestBody
    }).then(response => {
      m.redraw();
      const successMessage = app.translator.trans('huseyinfiliz-notificationhub.forum.modal_notification.notification_sent_message', {
        recipientsCount: response.recipientsCount
      });
      app.alerts.show({
        type: 'success'
      }, successMessage);
      this.hide();
    }, response => {
      this.sending = false;
      m.redraw();
      this.onerror(response);
      console.error('Error', response);
    });
  }
}
flarum.reg.add('huseyinfiliz-notificationhub', 'forum/components/NotificationUserModal', NotificationUserModal);